import createIcon from '../../createIcon';

/**
 * @component @name QueueMusic
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSA1SDIuNVY3SDE0LjVWNVpNMTQuNSA5SDIuNVYxMUgxNC41VjlaTTIuNSAxNUgxMC41VjEzSDIuNVYxNVpNMTYuNSA1VjEzLjE4QzE2LjE5IDEzLjA3IDE1Ljg1IDEzIDE1LjUgMTNDMTMuODQgMTMgMTIuNSAxNC4zNCAxMi41IDE2QzEyLjUgMTcuNjYgMTMuODQgMTkgMTUuNSAxOUMxNy4xNiAxOSAxOC41IDE3LjY2IDE4LjUgMTZWN0gyMS41VjVIMTYuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const QueueMusic = createIcon('QueueMusic', [
  [
    'path',
    {
      d: 'M14.5 5H2.5V7H14.5V5ZM14.5 9H2.5V11H14.5V9ZM2.5 15H10.5V13H2.5V15ZM16.5 5V13.18C16.19 13.07 15.85 13 15.5 13C13.84 13 12.5 14.34 12.5 16C12.5 17.66 13.84 19 15.5 19C17.16 19 18.5 17.66 18.5 16V7H21.5V5H16.5Z',
      key: '1dzbgy',
    },
  ],
]);

export default QueueMusic;
